import React from "react";

import { ValidateStatus } from "./types";
import { ErrorList } from "./ErrorList";
import styles from "./styles.scss";

interface FormItemInputMiscProps {
  prefixCls: string;
  children: React.ReactNode;
  errors: React.ReactNode[];
  hasFeedback?: boolean;
  validateStatus?: ValidateStatus;
  onErrorVisibleChange: (visible: boolean) => void;
}

export interface IFormItemInputProps {
  // help?: React.ReactNode;
  // extra?: React.ReactNode;
  status?: ValidateStatus;
  className?: string;
}

export const FormItemInput: React.FC<IFormItemInputProps & FormItemInputMiscProps> = (props) => {
  const { prefixCls, status, className, children, errors, onErrorVisibleChange } = props;

  const baseClassName = `${prefixCls}-item`;

  const inputDom = (
    <div className={styles[`${baseClassName}-control-input`]}>
      <div className={styles[`${baseClassName}-control-input-content`]}>{children}</div>
    </div>
  );
  const errorListDom = (
    <ErrorList errors={errors} status={status} prefixCls={prefixCls} onErrorVisibleChange={onErrorVisibleChange} />
  );

  return (
    <div className={className}>
      {inputDom}
      {errorListDom}
    </div>
  );
};
